import { render } from "./ElectionMap25.vue?vue&type=template&id=0defa816&scoped=true"
import script from "./ElectionMap25.vue?vue&type=script&lang=js"
export * from "./ElectionMap25.vue?vue&type=script&lang=js"

import "./ElectionMap25.vue?vue&type=style&index=0&id=0defa816&scoped=true&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0defa816"]])

export default __exports__